import React from "react";
import { useConsolidationPreference } from "../../hooks/useConsolidationView.js";

export default function RememberedDetails({ stateKey, children, onToggle, defaultOpen = false, ...props }) {
  const [open, setOpen] = useConsolidationPreference(`open:${stateKey}`, defaultOpen);
  return <details {...props} open={open} onToggle={(event) => {
    if (event.target !== event.currentTarget) return;
    setOpen(event.currentTarget.open);
    onToggle?.(event);
  }}>{children}</details>;
}
